import { fail, ok, type Result } from './result.js';
import { normalizarTexto } from './vo/texto.js';

/**
 * Lista de 30/10 (B), item 9: pausar e retomar a negociação pedem uma justificativa. A tela e a API usam esta mesma regra
 * (NFC, sem invisíveis nem espaço nas bordas, de 3 a 500 caracteres), para o botão do pop-up e o servidor nunca divergirem.
 */
export const MOTIVO_PAUSA_MIN = 3;
export const MOTIVO_PAUSA_MAX = 500;

export function motivoDaPausa(bruto: unknown): Result<string> {
  const v = typeof bruto === 'string' ? normalizarTexto(bruto) : '';
  if (v.length < MOTIVO_PAUSA_MIN) return fail('motivo_pausa.obrigatorio', 'Informe o motivo (ao menos 3 caracteres)', { campo: 'motivo', min: MOTIVO_PAUSA_MIN });
  if (v.length > MOTIVO_PAUSA_MAX) return fail('motivo_pausa.muito_longo', `O motivo passa de ${MOTIVO_PAUSA_MAX} caracteres`, { campo: 'motivo', max: MOTIVO_PAUSA_MAX });
  return ok(v);
}
